// AUTO-GENERATED by scripts/bump-version.mjs
// Do not edit manually.

export const APP_VERSION = process.env.VUE_APP_VERSION || '1.0.69'
export const APP_BUILT_AT = '2026-11-05T13:52:38.928Z'
